import { createFileRoute, redirect } from "@tanstack/react-router"
import { buildAccountUrl } from "@/app/auth"
export const Route = createFileRoute("/_authenticated/account/sessions")({
    beforeLoad: () => {
        throw redirect({ href: buildAccountUrl("sessions"), replace: true })
    },
})
